export const radius = {
  none: '0',
  2: '0.125rem',
  4: '0.25rem',
  8: '0.5rem',
  12: '0.75rem',
  16: '1rem',
  20: '1.25rem',
  24: '1.5rem',
  32: '2rem',
  full: '100%',
} as const

export const settings = {
  radii: radius,
}

export type Radius = keyof typeof radius | string

export type BorderProps = {
  borderBottomLeftRadius?: Radius[] | Radius
  borderBottomRightRadius?: Radius[] | Radius
  borderRadius?: Radius[] | Radius
  borderTopLeftRadius?: Radius[] | Radius
  borderTopRightRadius?: Radius[] | Radius
}

export type BorderTheme = typeof settings
